module.exports = __webpack_public_path__ + "img/Weapon_274.82d2823a.png";